module.exports = require('../impls/$find-best/async-find-best.js').asyncFindBest;